package com.example.mystybag.core.logic.helpers

import com.arkivanov.decompose.router.slot.ChildSlot
import com.arkivanov.decompose.router.slot.SlotNavigation
import com.arkivanov.decompose.router.slot.activate
import com.arkivanov.decompose.router.slot.dismiss
import com.arkivanov.decompose.value.Value
import com.example.mystybag.commonData.helpers.PlatformDefines.IOS
import com.example.mystybag.core.expected.LogHelper
import com.example.mystybag.commonData.expected.getOS
import com.example.mystybag.core.extensions.deleteFirst
import com.example.mystybag.core.extensions.generateRandomString
import com.example.mystybag.core.helpers.globalExceptionHandler
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.DialogConfig
import com.example.mystybag.core.logic.base.dialogChildSlot
import com.example.mystybag.core.model.PendingDialog
import kotlinx.coroutines.CoroutineName
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.coroutines.plus
import kotlinx.coroutines.suspendCancellableCoroutine
import kotlinx.coroutines.sync.Mutex
import kotlinx.coroutines.sync.withLock
import kotlin.coroutines.resume

enum class DialogResultType {
    POSITIVE,
    NEGATIVE,
    CANCELED,
    LINK_TEXT
}

interface UIDialogInterface {
    val dialogState: Value<ChildSlot<DialogConfig, DialogConfig>>
    fun dismissDialog(resultType: DialogResultType, data: Any? = null)
    suspend fun showDialog(config: DialogConfig): DialogResult
}

class UIDialogImpl(context: AppContext): UIDialogInterface {

    private val pendingDialogQueue  : MutableList<PendingDialog>   = mutableListOf()
    private val dialogNavigation    : SlotNavigation<DialogConfig> = SlotNavigation()
    private val mutex               = Mutex()

    override val dialogState = context.dialogChildSlot(
        source           = dialogNavigation,
        key              = "DialogSlot@".plus(generateRandomString()),
        handleBackButton = false
    )

    override suspend fun showDialog(config: DialogConfig) = suspendCancellableCoroutine { continuation ->
        (CoroutineScope(Dispatchers.Main) + globalExceptionHandler).launch(CoroutineName("showDialog")) {
            mutex.withLock {
                val dialog = PendingDialog(config, continuation)
                if (!pendingDialogQueue.contains(dialog))
                    pendingDialogQueue.add(dialog)

                if (dialogState.value.child?.instance == null) {
                    dialogNavigation.activate(config)
                }
            }
        }
    }

    override fun dismissDialog(resultType: DialogResultType, data: Any?) {
        (CoroutineScope(Dispatchers.Main) + globalExceptionHandler).launch(CoroutineName("dismissDialog")) {
            dialogNavigation.dismiss()
            mutex.withLock {
                //remove current
                if (pendingDialogQueue.isNotEmpty())
                    pendingDialogQueue.deleteFirst().continuation.takeIf { it.isActive }?.also {
                        if (getOS() == IOS) LogHelper.logEvent("resume in fun dismissDialog")
                        it.resume(DialogResult(resultType, data))
                    }
                pendingDialogQueue.firstOrNull()?.config
            }?.also {
                delay(250)
                dialogNavigation.activate(it)
            }
        }
    }
}

